import React from "react";
import EventStore from '@stores/EventStore';
import { observer } from 'mobx-react';
import PdfView from '@components/PdfView';
import TextViewer from '@components/TextViewer';
import PageHeader from '@components/PageHeader';
import PageFooter from '@components/PageFooter';
import SignatureCapture from '@components/SignatureCapture';
import AgreementStore from '@stores/AgreementStore';
import SignatureStore from '@stores/SignatureStore';
import utils from '@utils/utils';

@observer
export default class AgreementPage extends React.Component {
    constructor() {
        super();
        this.state = {
            signatureSubmitted: false
        }
        this.handleToggle = this.handleToggle.bind(this);
        this.signatureSubmitted = this.signatureSubmitted.bind(this);

        if(EventStore.eventObj.payload.agreementData) {
            sessionStorage.setItem('r', EventStore.eventObj.payload.agreementData);
        }

        AgreementStore.fetchContracts(sessionStorage.getItem('r'));
    }

    handleToggle(toggleItem) {
        var stateObj = {};
        stateObj[toggleItem] = !this.state[toggleItem];
        this.setState(stateObj);
    }

    signatureSubmitted(sig) {
        SignatureStore.submitSignature(sig.slice(22))
        .then(function() {
            this.signatureMessage = 'Signature has been processed.';
            this.setState({signatureSubmitted: true});
        }.bind(this))
        .catch(function(error) {
            this.signatureMessage = error.message || "Error Occured.";
            this.setState({signatureSubmitted: true});
        }.bind(this))
    }

    render() {
        var mainContent;
        var agreementsCtx = [];
        if(!AgreementStore.loading && !AgreementStore.error) {
            if(Array.isArray(AgreementStore.contracts.slice())){
                AgreementStore.contracts.forEach(function(agreementObj){
                    agreementsCtx.push(<Agreement key={agreementObj.element} agreementObj={agreementObj} closeViewer={this.handleToggle} displayCtx={this.state[agreementObj.element]}/>)
                }.bind(this))
            }
            mainContent = (
                <div>
                    {agreementsCtx}
                    { this.state.signatureSubmitted ? 
                        (<h2 className="margin-top-50 center">{this.signatureMessage}</h2>) :
                        (<SignatureCapture sigID="signature" submitSig={this.signatureSubmitted}/>)
                    }
                </div>);
        } else if(AgreementStore.loading === true) {
            mainContent = (
                <div className="center">
                    <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></i>
                    <span className="sr-only">Loading...</span>
                </div>);
        } else {
            mainContent = (
                <div className="center">
                    { AgreementStore.error }
                </div>);
        }

        return (
            <div>
                <PageHeader title="Agreements"/>
                {mainContent}
                <PageFooter />
            </div>
        );
    }
}

function Agreement(props) {
    var context = (<div></div>);

    if(props.agreementObj.type === 'html'){
        context = (
            <div className="margin-bot-10">
                <div className="margin-bot-10">
                    <div className="inline-block mob-center">
                        <h3 className="">{props.agreementObj.title}</h3>
                    </div>
                    <div className="inline-block mob-center">
                        <button className="button margin-h-15" onClick={() => {props.closeViewer(props.agreementObj.element)}}>View Full</button>
                    </div>
                </div>
                { props.displayCtx ? 
                    (<TextViewer containerID={props.agreementObj.element} textBody={props.agreementObj.body} closeViewer={() => {props.closeViewer(props.agreementObj.element)}} />) : ''
                }
                <div dangerouslySetInnerHTML={{__html: props.agreementObj.disclaimer}} />
            </div>);
    } else if(props.agreementObj.type === 'pdf'){
        context = (
            <div className="margin-bot-10">
                <div className="margin-bot-10">
                    <div className="inline-block mob-center">
                        <h3 className="">{props.agreementObj.title}</h3>
                    </div>
                    <div className="inline-block mob-center">
                        <button className="button margin-h-15" onClick={() => {props.closeViewer(props.agreementObj.element)}}>View Full</button>
                    </div>
                </div>
                { props.displayCtx ? 
                    (<PdfView containerID={props.agreementObj.element} pdfData={props.agreementObj.body} closePdf={() => {props.closeViewer(props.agreementObj.element)}}/>) : ''
                }
                <div dangerouslySetInnerHTML={{__html: props.agreementObj.disclaimer}} />
            </div>);
    }

    return context;
}


// WEBPACK FOOTER //
// ./src/js/pages/AgreementPage.js